import { Button, colors } from "@mui/material";
import materialUI from "material-UI";
import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 580px;
  max-height: 90vh;
  background: #ffffff;
  border-radius: 8px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const Header = styled.div``;

export const Body = styled.div`
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
  }
`;

export const TextTitle = styled.p`
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 29.05px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #101828;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;

export const CancelButton = styled.button`
  background: #ffffff;
  width: 100%;
  height: 44px;
  border: 1px solid #a3a3a6;
  border-radius: 8px;
  padding: 10px 18px;
  cursor: pointer;

  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
`;

export const SendButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #4caf50;
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  cursor: pointer;

  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  color: #ffffff;
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 4px;
  label {
    display: none;
  }

  .MuiInputBase-root {
    border-radius: 8px;
    height: 40px;
    margin: 0;
  }
  .MuiInputBase-input {
    height: 40px;
  }
  .MuiTypography-root {
    padding-top: 1px;
  }
  .MuiOutlinedInput-input {
    padding: 0 12px;
  }

  .MuiOutlinedInput-adornedEnd {
    padding-right: 4px;
  }
  .Mui-focused {
    fieldset {
      border-color: #2d5bff !important;
    }
  }
  &.input-disabled {
    background-color: #d0d5dd;
    input {
      color: #a3a3a6;
    }
  }
  .MuiInputBase-root.Mui-disabled {
    background-color: #d0d5dd !important;
    input {
      color: #a3a3a6 !important;
    }
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: #888;
    }
  }
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const ButtonVincular = styled.button`
  height: 31px;
  width: 256px;
  border-radius: 6px;
  background-color: #2d5bff;
  color: white;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.01em;
  :hover {
    cursor: pointer;
    opacity: 0.9;
  }

  :disabled {
    opacity: 50%;
    color: white;
    cursor: not-allowed;
  }
`;

export const TextCodigoFicha = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #424248;
`;

export const TextPagamentoSinal = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 12px;
  text-align: left;
`;

export const TextOptions = styled.p`
  //styleName: MD/Regular;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
`;
